<template>
  <vs-table hover-flat v-if="timeGroups && timeGroups.length" :data="timeGroups">
    <template slot="thead">
      <vs-th v-text="$t('list')"></vs-th>
      <vs-th v-text="$t('time_conditions_upload_file_file_name')"></vs-th>
      <vs-th class="text-center" v-text="$t('action')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="$t(`time_conditions_upload_file_${tr.value}`)"></vs-td>
        <vs-td>
          <span v-if="tr.soundFile" v-text="tr.soundFile.filename"/>
        </vs-td>
        <vs-td class="text-center">
          <div class="flex justify-center">
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click="$emit('timeConditionSoundFile', key, tr.value)"></vs-button>&nbsp;
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" v-if="tr.soundFile" @click="$emit('destroyTimeConditionSoundFile', key)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.TimeConditions.SoundFile.List',
  props: {
    timeGroups: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
